import { doPrivatePostRequest } from "./requests";

export const getGlobalSearch = (_search_key, _search_context, _token) => {
  const path = "/search";

  const params = {
    search_context: _search_context, // 'full', 'full, users, meets',
    search_key: _search_key,
  };

  return doPrivatePostRequest(params, path, _token);
};
